export const categories = [
  {
    slug: "yiqu",
    name: "一区",
    description: "明星娱乐圈劲爆黑料，每日更新最新吃瓜内容",
    icon: "ri-fire-line",
    color: "accent",
  },
  {
    slug: "erqu",
    name: "二区",
    description: "网红达人圈独家爆料，深度揭秘行业内幕",
    icon: "ri-flashlight-line",
    color: "secondary",
  },
];